import { api } from './client';

/**
 * Your cast (#1341) — status is free; propose is one paid pass; neither writes.
 * Accept writes through Book Notes add-cards (persistAcceptedDocsNote).
 */
export const bookCastApi = {
  status: (storyId) => api.get(`/stories/${storyId}/cast`),
  propose: (storyId) => api.post(`/stories/${storyId}/cast/propose`, {}),
};
